import * as React from "react";
const SvgFiRrCentSign = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M20.62 17.47A8.34 8.34 0 0 1 13.19 22h-.18v1c0 .55-.45 1-1 1s-1-.45-1-1v-1.01c-4.44-.19-8-3.87-8-8.35v-3.27C3 5.87 6.56 2.2 11 2.01V1c0-.55.45-1 1-1s1 .45 1 1v1h.18c3.2 0 6.07 1.78 7.49 4.65a1 1 0 1 1-1.79.89A6.33 6.33 0 0 0 13.18 4h-1.82C7.85 4 5 6.85 5 10.36v3.27c0 3.51 2.85 6.36 6.36 6.36h1.82c2.39 0 4.56-1.32 5.66-3.45.25-.49.86-.68 1.35-.43s.68.86.43 1.35z"
    />
  </svg>
);
export default SvgFiRrCentSign;
